import * as Types from '../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHiringEventDataByJobKeyQueryVariables = Types.Exact<{
  jobKey: Types.Scalars['ID']['input'];
}>;


export type GetHiringEventDataByJobKeyQuery = { __typename?: 'Query', findHiringEvents?: { __typename?: 'FindHiringEventsPayload', result: Array<{ __typename?: 'FindHiringEventResult', hiringEvent: { __typename?: 'HiringEvent', id: string, companyName: string, eventLocale: string, isApproved: boolean, posting: { __typename?: 'HiringEventPosting', companyAboutHTML: string, customPerks: Array<string>, directionsHTML: string, eventRequirements: Array<string>, genericPerks: Array<Types.HiringEventGenericPerk>, hiringEventIntroHTML: string, interviewsOffered: boolean }, interviewConfig: { __typename?: 'HiringEventInterviewConfig', dressCodeDescription: string, requiredItems: Array<string>, availability: { __typename?: 'HiringEventAvailabilityResource', timePeriod: Array<{ __typename?: 'HiringEventAvailablePeriod', startTime: string, endTime: string }> }, location: { __typename: 'HiringEventGenericOnlineLocation', technologyRequirements: string, timezone: string } | { __typename: 'HiringEventPhoneLocation', technologyRequirements: string, timezone: string } | { __typename: 'HiringEventPhysicalLocation', name: string, streetAddress: string, city: string, postalCode?: string | null, countryName: string, admin1Code?: string | null, formattedLocation: string, timezone: string } | { __typename: 'HiringEventVIPLocation', technologyRequirements: string, timezone: string }, schedulingConfig: { __typename?: 'HiringEventSchedulingConfig', timeSlotDurationMs: number, useInterviewSlots: boolean } } } }> } | null };


export const GetHiringEventDataByJobKeyDocument = gql`
    query GetHiringEventDataByJobKey($jobKey: ID!) {
  findHiringEvents(input: {jobKeys: [$jobKey]}) {
    result {
      hiringEvent {
        id
        companyName
        eventLocale
        isApproved
        posting {
          companyAboutHTML
          customPerks
          directionsHTML
          eventRequirements
          genericPerks
          hiringEventIntroHTML
          interviewsOffered
        }
        interviewConfig {
          availability {
            timePeriod {
              startTime
              endTime
            }
          }
          dressCodeDescription
          location {
            timezone
            ... on HiringEventPhysicalLocation {
              __typename
              name
              streetAddress
              city
              postalCode
              countryName
              admin1Code
              formattedLocation
            }
            ... on HiringEventVIPLocation {
              technologyRequirements
              __typename
            }
            ... on HiringEventPhoneLocation {
              technologyRequirements
              __typename
            }
            ... on HiringEventGenericOnlineLocation {
              technologyRequirements
              __typename
            }
          }
          requiredItems
          schedulingConfig {
            timeSlotDurationMs
            useInterviewSlots
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetHiringEventDataByJobKeyQuery__
 *
 * To run a query within a React component, call `useGetHiringEventDataByJobKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHiringEventDataByJobKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHiringEventDataByJobKeyQuery({
 *   variables: {
 *      jobKey: // value for 'jobKey'
 *   },
 * });
 */
export function useGetHiringEventDataByJobKeyQuery(baseOptions: Apollo.QueryHookOptions<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables> & ({ variables: GetHiringEventDataByJobKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables>(GetHiringEventDataByJobKeyDocument, options);
      }
export function useGetHiringEventDataByJobKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables>(GetHiringEventDataByJobKeyDocument, options);
        }
export function useGetHiringEventDataByJobKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables>(GetHiringEventDataByJobKeyDocument, options);
        }
export type GetHiringEventDataByJobKeyQueryHookResult = ReturnType<typeof useGetHiringEventDataByJobKeyQuery>;
export type GetHiringEventDataByJobKeyLazyQueryHookResult = ReturnType<typeof useGetHiringEventDataByJobKeyLazyQuery>;
export type GetHiringEventDataByJobKeySuspenseQueryHookResult = ReturnType<typeof useGetHiringEventDataByJobKeySuspenseQuery>;
export type GetHiringEventDataByJobKeyQueryResult = Apollo.QueryResult<GetHiringEventDataByJobKeyQuery, GetHiringEventDataByJobKeyQueryVariables>;